import React, { useEffect, useRef, useState } from 'react';
import "./ResultChart.css";
import {
    Chart,
    RadarController,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
} from 'chart.js';
import lock from "../../images/lock1.svg";
import { useParams } from "react-router-dom";

import { END_URL, IMG_URL, SITE_URL } from "../../config";
import { Link } from 'react-router-dom';

import ProgressBarNew from '../ProgressBarNew/ProgressBarNew';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight,faTimes } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from 'react-router-dom';
import buttonloader from "../../images/buttonloader.gif";
import { toPng } from 'html-to-image';
import download from 'downloadjs';
import loadimg from "../../images/loader_wish.gif";

import SharePopup from "./SharePopup";

import { faFacebook, faInstagram, faLinkedin, faXTwitter, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Trail from '../Trail/Trail';


function ResultChart({ resultRef,onLoginChange, subplan, token, result, testdata, demension, opacity, past_test,tierData ,showlock,UnLockModal,setUnLockModal}) {

    // past_test=true

    const chartRef = useRef(null);

    const canvasRef = useRef(null);

    const { slug, test_slug } = useParams();

    const [slugState, setSlugState] = useState(slug);

    const [testSlugState, setTestSlugState] = useState(test_slug);


    const [Result, setResult] = useState(result);

    const [TestData, setTestData] = useState(testdata);

    const [ChartLabel, setChartLabel] = useState([]);

    const [selectedLabel, setSelectedLabel] = useState(null);
    const [selectedPercentage, setSelectedPercentage] = useState(null);
    const [SelectedIndex, setSelectedIndex] = useState(0);
    const location = useLocation();
    const isEmailResultsPage = location.pathname.includes('/email-results/');

    const [ButtonLoad, setButtonLoad] = useState(true);

    const [Loading,setLoading] = useState(false);

    const [EmailSuccess, setEmailSuccess] = useState(false);

    const [copied, setCopied] = useState(false);

    const [isSharePopupOpen, setIsSharePopupOpen] = useState(false);


    const handleShare = () => {

        setIsSharePopupOpen(true);
    };

    const dimension_name = demension?.name;

    const dimension_slug = dimension_name
                        ? dimension_name
                            .toLowerCase()
                            .trim()
                            .replace(/\s+/g, '-')
                            .replace(/[^\w\-]+/g, '')
                            .replace(/\-\-+/g, '-')
                            .replace(/^-+/, '')
                            .replace(/-+$/, '')
                        : '';         

    const shareUrl = `${IMG_URL}/view-image/${demension?.id}/${dimension_slug}?v=${demension?.version}`;

//     const shareUrl =
//   `https://personalitypeek.com/share.php?img=${demension?.share_image}&id=${demension?.id}&slug=${dimension_slug}`;

    const filename=  demension?.share_image?.split('/').pop() || "";
   
    // const shareImg = `${IMG_URL}/og-images/${demension?.share_image}`;

    const shareImg = `${demension?.share_image}`;

    const shareTitle = demension?.name || "Archetype";
    const shareText = `${demension?.name || "Archetype"} result!`;

    const EmailSuccessclose = () => {
        setEmailSuccess(false);
    }


    useEffect(() => {

        if (testdata) {

            setSlugState(testdata.test?.slug ?? slug); 

            setTestSlugState(testdata.test?.test_slug ?? test_slug);
            setTestData(testdata);
        }
    }, [testdata, slug, test_slug]); 


    const HandlePayment = (price) => {

        const InitializePayment = async () => {

            try {

                setButtonLoad(true);

                const response = await fetch(`${END_URL}/free-test-payment`, {

                    method: "POST",
                    headers: {

                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify({ type: 'free_test', price: price, test_id: TestData.test?.id }),
                });

                const data = await response.json();

                console.log(data.payment, 'fetch data');
                if (data.payment) {

                    setButtonLoad(false);
                    window.location.href = data.payment;
                } else {

                    setButtonLoad(false);

                    console.error("Invalid response:", data);
                    alert("An error occurred while processing the request.");
                }

            } catch (error) {

                console.error("Error sending result:", error);
            }
        };

        InitializePayment();

    };


    // useEffect(() => {
    //     if (Array.isArray(TestData?.data) && TestData?.data?.length > 0) {
    //         const chartfilter = TestData?.data?.map((item, index) => {
    //             // Fallback-safe labels
    //             let leftLabel = item?.resultcategory ? item.resultcategory.left_label : item?.leftlabel;
    //             let rightLabel = item?.resultcategory ? item.resultcategory.right_label : item?.rightlabel;

    //             if (leftLabel === "") leftLabel = item?.leftlabel;
    //             if (rightLabel === "") rightLabel = item?.rightlabel;

    //             return {
    //                 id: index,
    //                 label: item.letter === "left" ? leftLabel : rightLabel,
    //                 percentage: item.letter === "left" ? item?.left_result : item?.right_result,
    //             };
    //         });



    //         setChartLabel(chartfilter);

    //         setSelectedLabel(chartfilter[SelectedIndex]?.label);
    //         setSelectedIndex(chartfilter[SelectedIndex]?.id);
    //         setSelectedPercentage(Math.round(chartfilter[0]?.percentage));
    //     }
    // }, [TestData]);

    // useEffect(() => {


    // }, [SelectedIndex]);


    // useEffect(() => {
    //     Chart.register(
    //         RadarController,
    //         RadialLinearScale,
    //         PointElement,
    //         LineElement,
    //         Filler,
    //         Tooltip,
    //         Legend
    //     );

    //     if (!canvasRef.current) return;
    //     const ctx = canvasRef.current.getContext('2d');

    //     if (chartRef.current) {
    //         chartRef.current.destroy();
    //     }

    //     chartRef.current = new Chart(ctx, {
    //         type: 'radar',
    //         data: {
    //             labels: ChartLabel.map((item) => item.label.charAt(0).toUpperCase()),
    //             datasets: [{
    //                 data: ChartLabel.map((item) => Math.round(item.percentage)),
    //                backgroundColor: 'rgba(128, 0, 128, 0.3)', // 👈 purple fill with transparency
    // borderColor: 'rgba(128, 0, 128, 0.4)', // 👈 purple border line
    //                 borderWidth: 2,
    //                 pointBackgroundColor: [
    //                     '#800080',
    //                     '#daa520',
    //                     '#3fa8eb',
    //                     '#19bbab',
    //                     '#ff8183',
    //                     '#b8f976'
    //                 ],

    //                 pointBorderColor: [
    //                     '#800080',
    //                     '#daa520',
    //                     '#3fa8eb',
    //                     '#19bbab',
    //                     '#ff8183',
    //                     '#b8f976'
    //                 ]
    //                 // pointBackgroundColor: '#ffec8870', outer border pointer background color of light pink (light yellow)
    //                 // pointBorderColor: '#648f75', outer border pointer border for the background color of light pink
    //             }]
    //         },

 
    //         options: {
    //             responsive: true,

    //             onHover: (event, elements, chart) => {
    //                 const canvas = event.native?.target || event.target;
    //                 const { x, y } = event;

    //                 const rScale = chart.scales.r;
    //                 const ctx = chart.ctx;
    //                 const labels = chart.data.labels;
    //                 const fontSize = 14;
    //                 ctx.font = `bold ${fontSize}px Arial`;

    //                 const labelItems = rScale._pointLabelItems;

    //                 let isHoveringLabel = false;

    //                 for (let i = 0; i < labels.length; i++) {
    //                     const label = labels[i];
    //                     const labelX = labelItems[i].x;
    //                     const labelY = labelItems[i].y;
    //                     const textAlign = labelItems[i].textAlign; // 'center' | 'left' | 'right'
    //                     const textBaseline = labelItems[i].textBaseline; // 'middle' | 'top' | etc.
    //                     const textWidth = ctx.measureText(label).width;
    //                     const textHeight = fontSize;

    //                     // Adjust x based on textAlign
    //                     let boxLeft = labelX;
    //                     if (textAlign === 'center') {
    //                         boxLeft = labelX - textWidth / 2;
    //                     } else if (textAlign === 'right') {
    //                         boxLeft = labelX - textWidth;
    //                     }

    //                     // Adjust y based on textBaseline
    //                     let boxTop = labelY;
    //                     if (textBaseline === 'middle') {
    //                         boxTop = labelY - textHeight / 2;
    //                     } else if (textBaseline === 'bottom') {
    //                         boxTop = labelY - textHeight;
    //                     } // 'top' doesn't need adjustment

    //                     // Debug: see the red box
    //                     // ctx.strokeStyle = 'red';
    //                     // ctx.strokeRect(boxLeft, boxTop, textWidth, textHeight);

    //                     if (
    //                         x >= boxLeft &&
    //                         x <= boxLeft + textWidth &&
    //                         y >= boxTop &&
    //                         y <= boxTop + textHeight
    //                     ) {
    //                         isHoveringLabel = true;
    //                         break;
    //                     }
    //                 }

    //                 canvas.style.cursor = isHoveringLabel ? 'pointer' : 'default';
    //             },

    //             onClick: (event, elements, chart) => {

    //                 if (elements.length > 0) {
    //                     const index = elements[0].index;
    //                     const item = ChartLabel[index];
    //                     setSelectedLabel(item.label);
    //                     setSelectedPercentage(Math.round(item.percentage));
    //                 } else {

    //                     const { x, y } = event;
    //                     const centerX = chart.chartArea.left + (chart.chartArea.right - chart.chartArea.left) / 2;
    //                     const centerY = chart.chartArea.top + (chart.chartArea.bottom - chart.chartArea.top) / 2;
    //                     const angle = Math.atan2(y - centerY, x - centerX);
    //                     const angleDeg = (angle * (180 / Math.PI) + 360) % 360;

    //                     const labelIndex = findClosestLabelIndex(angleDeg, chart);
    //                     if (labelIndex !== -1) {
    //                         const item = ChartLabel[labelIndex];
    //                         setSelectedLabel(item.label);
    //                         setSelectedPercentage(Math.round(item.percentage));
    //                     }
    //                 }
    //             },
    //             plugins: {
    //                 title: {
    //                     display: true,
    //                     text: "",
    //                     font: {
    //                         size: 18
    //                     },
    //                     color: '#657aed'
    //                 },
    //                 legend: {
    //                     display: false
    //                 },
    //                 tooltip: {
    //                     enabled: true
    //                 }
    //             },


    //             scales: {
    //                 r: {
    //                     angleLines: {
    //                         display: true,
    //                         lineWidth: 1, // increase line thickness
    //                         color: '#B0B0B0' //center crossing lines only
    //                     },
    //                     ticks: {
    //                         backdropColor: 'transparent', //number's bg color
    //                         color: 'transparent', //numbers color
    //                     },
    //                     grid: {
    //                         color: '#B0B0B0',  // grid circle color ,mmeants the spinder connection chain
    //                         lineWidth: 1       // thicker border lines
    //                     },
    //                     pointLabels: {
    //                         color: '#474747',     // label color (around chart)
    //                         font: {
    //                             size: 15,
    //                             color: 'black'
    //                         },
    //                     },

    //                     suggestedMin: 0,
    //                     suggestedMax: 100
    //                 }
    //             }
    //         }




    //     });

    //     return () => {
    //         if (chartRef.current) {
    //             chartRef.current.destroy();
    //         }
    //     };
    // }, [ChartLabel]);


    // function findClosestLabelIndex(angleDeg, chart) {
    //     const totalLabels = chart.data.labels.length;
    //     const angleOffset = -90; // Because Chart.js starts at 270° (top)

    //     const normalizedAngle = (angleDeg - angleOffset + 360) % 360;
    //     const step = 360 / totalLabels;

    //     const index = Math.round(normalizedAngle / step) % totalLabels;
    //     return index;
    // }

    const colors = ["purple", "#daa520", "#3fa8eb", "#19bbab", "#ff8183", "#b8f976"];

    const LoginShow = () => {

        // window.scrollTo({ top: 0, behavior: 'smooth' });
        onLoginChange(true);
    };


    const currentPath = location.pathname;
    const isResultPage = currentPath.includes('/result/');

    const DarkResult = currentPath.includes('/result/user');


    const handleDownloadImage = async () => {
        if (resultRef.current) {

            setLoading(true);

            const originalClassName = resultRef.current.className;

            resultRef.current.classList.add('force-desktop-style');

            await new Promise(resolve => setTimeout(resolve, 100));

            try {
                const dataUrl = await toPng(resultRef.current, {
                    quality: 1,
                    backgroundColor: '#ffffff',
                    style: {
                        transform: 'scale(1)',
                        transformOrigin: 'top left',
                        width: resultRef.current.offsetWidth + "px",
                        height: resultRef.current.offsetHeight + "px"
                    }
                });

                const blob = await (await fetch(dataUrl)).blob();

                const formData = new FormData();
                formData.append('image', blob, 'result.png'); 
                formData.append('slug', slugState);               
                formData.append('test_slug', testSlugState);    

                const response = await fetch(`${END_URL}/upload-result-image`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token}`,
                        
                    },
                    body: formData
                });

                const result = await response.json();
                console.log("Image upload result:", result);

            } catch (error) {
                console.error('Image generation or upload failed:', error);
            } finally {
                resultRef.current.className = originalClassName;

                 setLoading(false);

                 setEmailSuccess(true);
            }
        }
    };


    return (
        <div className="reschar-main" >

            {Loading && (
                <div className="loader-overlay">
                    <img src={loadimg} alt="Loading..." className="loader-gif" />
                </div>
            )}

            <div className="reschar-sub-main" ref={resultRef} /*style={divStyle}*/ >
                <div className="row chart-title">
                    <h5> {TestData?.test?.result_test_name} - {demension?.name} {result?.map(item => item.final_letter).join(' ')} </h5>
                </div>
                <div className="row chart-row1">

                    {/* <div className={subplan == 'hide_graph' ? 'col-12 col-sm-12 col-md-7 col-lg-7 newchart_icon hide_graph' : 'col-12 col-sm-12 col-md-7 newchart_icon col-lg-7' } >  */}


                    <div className={subplan == 'hide_graph' ? 'newchart_icon hide_graph' : 'newchart_icon' } > 


                        {/* <div className="reschart-box">
                            <h6>Breakdown of Dimensions</h6>
                            <div className="reschart-menus">


                                {TestData?.data?.map((item, index) => {

                                    let leftLabel = item?.resultcategory ? item.resultcategory.left_label : item?.leftlabel;
                                    let rightLabel = item?.resultcategory ? item.resultcategory.right_label : item?.rightlabel;

                                    // Further fallback if label is empty string
                                    if (leftLabel === "") leftLabel = item?.leftlabel;
                                    if (rightLabel === "") rightLabel = item?.rightlabel;

                                    return (
                                        <ProgressBarNew
                                            key={index}
                                            percentage={Math.round(item.letter === 'left' ? item.left_result : item.right_result)}
                                            leftLabel={leftLabel}
                                            rightLabel={rightLabel}
                                            color={colors[index % colors.length]}
                                            position={'left'}
                                            positionlabel={item.letter === 'left' ? leftLabel : rightLabel}
                                        />
                                    );
                                })}

                            </div>
                        </div> */}

                          <Trail showlock={showlock}  testdata={TestData} tierData={tierData} UnLockModal={UnLockModal} setUnLockModal={setUnLockModal} />
        
                    </div>


                {/* {subplan != 'hide_graph' && (

                    <div className="col-12 col-sm-12 col-md-5 col-lg-5">
                        <div className="reschart-char">
                            <h6>User Profile Radar Chart</h6>
                            <div className="chart-main-graph">
                          

                                <p>{selectedLabel ? `${selectedPercentage}% ${selectedLabel}` : ""}</p>

                                <div className="chart-main-graph-add">

                                    <canvas ref={canvasRef}></canvas>

                                </div>  

                            </div>

                            <div className="reschart-all-labels">

                                {TestData?.data?.map((item, index) => {

                                    let leftLabel = item?.resultcategory ? item.resultcategory.left_label : item?.leftlabel;
                                    let rightLabel = item?.resultcategory ? item.resultcategory.right_label : item?.rightlabel;

                                    if (leftLabel === "") leftLabel = item?.leftlabel;
                                    if (rightLabel === "") rightLabel = item?.rightlabel;

                    
                                    let Resultlabel = item.letter === "left" ? leftLabel : rightLabel;

                                    let color = item?.color ?? colors[index % colors.length]; 

                                    return (
                                        
                                    <div key={index} className="reschar">

                                        <span style={{ background: color }}></span>

                                      <span>{Resultlabel}</span>

                                    </div>

                                    );
                                })}

                            </div>

                        </div>
                    </div>

                )} */}



                </div>
            </div>

            {!opacity && subplan && false &&

                <div className="arche-last-div">

                    <span><img src={lock} alt="" /></span>

                    <h5>{subplan[0]?.heading}</h5>

                    <button className="arche-btn1">$ {subplan[0]?.price}</button>

                    <h6>{subplan[0]?.title}</h6>

                    <p>{subplan[0]?.description}</p>

                    {token ? (
                        <a>
                            <button className="arche-btn2" onClick={() => HandlePayment(subplan[0]?.price)}>{subplan[0]?.heading} {ButtonLoad && <img src={buttonloader} alt="Loading" style={{ marginLeft: '0px', width: '33px', height: '33px'}} /> }</button>
                        </a>
                    ) :
                        (
                            <a>
                                <button className="arche-btn2" onClick={LoginShow} >{subplan[0]?.heading}</button>
                            </a>
                        )
                    }


                </div>
            }

        {(
        (
            (!isEmailResultsPage) 
        ) || (past_test && !isEmailResultsPage) || DarkResult
        ) && (

            <div className="row rest-last-row-btns result-page1">
                <div className="rest-last-btns ">

                    { (!isEmailResultsPage || DarkResult) && token !='admin_token' && subplan != 'hide_graph'   && (
                   
                        <>
                            {demension?.share_image && (
                                <div className="flex items-center space-x-2">
                            
                                    <button
                                        className="button freereul"
                                        onClick={handleShare}
                                    >
                                       {demension?.share_btn_text || ' Share Result'}
                                <span>
                                    <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                </span>
                                    </button>

                                    {/* Copied Message */}
                                    {copied && (
                                        <span className="ml-2 text-green-500 text-sm font-medium">
                                        Link copied!
                                        </span>
                                    )}
                                </div>
                            )}
                            {(!isResultPage || DarkResult) && (
                                <button
                                    className="button freereul"
                                    onClick={handleDownloadImage}
                                >
                                {demension?.email_btn_label}
                                    <span>
                                        <FontAwesomeIcon className="icc" icon={faArrowRight} />
                                    </span>
                                </button>
                            )}
                        </>
                    )}

                    {past_test && !isEmailResultsPage && (
                        <a
                            className="button pastclass"
                            href={`/pastresults/${slugState}`}
                            style={{ marginTop: '0px' }}
                        >
                            View Past Results
                            <span>
                                <FontAwesomeIcon className="icc" icon={faArrowRight} />
                            </span>
                        </a>
                    )}

                </div>
            </div>
        )}


            <SharePopup
                isOpen={isSharePopupOpen}
                onClose={() => setIsSharePopupOpen(false)}
                shareUrl={shareUrl}
                shareImg={shareImg}
                shareTitle={shareTitle}
                shareText={shareText}
                TestUrl={`${SITE_URL}/test/${slug}`}
                filename={filename}
            />

            {EmailSuccess && (
                <div className="modal-question">
                    <div className="modal-test">
                        <div className="modal-content-test">

                          <div className='modal-dymic' dangerouslySetInnerHTML={{ __html:demension.email_success_message }} />

                            <button className="modal-close-button-test" onClick={EmailSuccessclose}>
                                Ok
                            </button>
                            
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default ResultChart;
